import { ILocation, ICountry, IlocalizationForLangDtoList } from 'interfaces';

const getLocalizationText = (
  location: IlocalizationForLangDtoList[],
  language: string,
) =>
  location.find(
    (item) => item.localizationLanguageCode === language.toLocaleUpperCase(),
  )?.localizationText;

export const countryTranslate = (
  language: string,
  country: ICountry | undefined,
) => {
  const countryTranslations = country?.localizationForLangDtoList ?? [];

  return (
    getLocalizationText(countryTranslations, language) ??
    country?.countryName ??
    ''
  );
};

export const cityTranslate = (
  language: string,
  city: ILocation | undefined,
) => {
  const cityTranslations = city?.localizationForLangDtoList ?? [];

  return (
    getLocalizationText(cityTranslations, language) ?? city?.cityName ?? ''
  );
};

export const formattedLocationName = (city: string, country: string) => {
  return `${city}, ${country}`;
};

export const localizationTranslate = (
  language: string,
  location: ILocation | undefined,
) => {
  if (!location) return '';

  const city = cityTranslate(language, location);
  const country = countryTranslate(language, location.country);

  if (location.cityName === 'Remote') {
    return `${country}, ${city}`;
  }

  return `${city}, ${country}`;
};
